'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _styledComponents2.default.label.withConfig({
  componentId: 'o70mi3-0'
})(['display:block;margin-bottom:calc(', ' / 3);line-height:', ';', ''], function (p) {
  return p.theme.spacingUnit;
}, function (p) {
  return p.theme.inputLineHeight;
}, function (p) {
  return ['side_by_side', 'two_columns', 'three_columns'].includes(p.optionDisplay) && '\n    margin-right: calc(' + p.theme.spacingUnit + ' / 1);\n    display: inline-block;\n    width: auto;\n  ';
});